import React, { useEffect, useRef, useState } from 'react';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import { Tooltip } from '@/components';
import { Icon } from '@/components';
import classNames from 'classnames';
interface HoverIconProps {
  title?: string;
  name: string;
  className?: string;
  style?: any;
  onClick?: any;
  panelVisible?: boolean;
}

const HoverIcon: React.FC<HoverIconProps> = inject()(
  observer((props: HoverIconProps) => {
    const { title, name, className, style, onClick, panelVisible = false, ...rest } = props;
    const hoverRef = useRef<any>();

    return (
      <div
        className={classNames(s.wrapper, className, panelVisible ? s.active : '')}
        style={style}
        ref={hoverRef}
        onClick={onClick}
      >
        {title && !panelVisible ? (
          <Tooltip getPopupContainer={() => hoverRef.current} showArrow title={title}>
            <div {...rest} ref={hoverRef}>
              <Icon name={name} size={28} mode="symbol" className={s.icon} />
            </div>
          </Tooltip>
        ) : (
          <div {...rest} ref={hoverRef}>
            <Icon name={name} size={28} mode="symbol" className={s.icon} />
          </div>
        )}
      </div>
    );
  })
);

export default HoverIcon;
